// EN
export const listingRatesManager = {
  header: {
    eyebrow: "Abgeleitete Raten",
    title: "Raten des Inserats",
    subtitle:
      "Zentralisieren Sie Ihre Ratenkonfiguration und wenden Sie sie auf die gewünschten Einheiten an, auch über mehrere Inserate hinweg, ohne die Arbeit einzeln zu wiederholen.",
    newRate: "Neue Rate",
  },
  baseInfo: {
    title: "Grundpreise pro Nacht",
    perNight: "/ Nacht",
    hint: "Abgeleitete Raten werden als Anpassung (% oder fester Betrag) auf diese Grundpreise berechnet.",
  },
  states: {
    loading: "Raten des Inserats werden geladen...",
    emptyTitle: "Noch keine abgeleiteten Raten",
    emptyText:
      "Erstellen Sie eine abgeleitete Rate, um Preise mit Kanälen wie Booking.com oder Airbnb zu synchronisieren.",
    createFirst: "Erste Rate erstellen",
  },
  group: {
    unitsCount: "{count} Einheit | {count} Einheiten",
    manageTitle: "Ratengruppe verwalten",
    manage: "Verwalten",
    modalTitle: "Rate verwalten",
    apply: "Anwenden",
    appliedUnits: "Einheiten, in denen sie angewendet wird",
    removeSyncedWarn:
      "Diese Rate ist mit dem Kanal verbunden. Wenn Sie sie entfernen, wird sie auch im Kanal gelöscht.",
    removeConfirm: "Diese Rate aus dieser Einheit entfernen?",
    removing: "Wird entfernt...",
    confirmRemove: "Ja, entfernen",
    removeTitle: "Aus dieser Einheit entfernen",
    remove: "Entfernen",
  },
  chips: {
    connect: "Verbinden",
    paused: "Pausiert",
    syncedTitle: "Mit dem Kanal synchronisiert",
  },
  actions: {
    editTitle: "Rate bearbeiten",
    duplicateTitle: "Duplizieren oder kopieren",
    pause: "Verkauf pausieren",
    resume: "Verkauf fortsetzen",
    deleteTitle: "Löschen",
  },
  modal: {
    createTitle: "Neue abgeleitete Rate",
    editTitle: "Rate bearbeiten",
    importPlaceholder: "Von einer bestehenden Rate übernehmen…",
    namePlaceholder: "Name der Rate",
    percentage: "% Prozentsatz",
    fixed: "Fester Wert",
    derivationHint: "Ein negativer Wert senkt den Grundpreis, ein positiver erhöht ihn.",
    searchPlaceholder: "Suchen…",
    unitsCounter: "{selected} / {total} Einheiten",
    selectAll: "Alle auswählen",
    deselectAll: "Auswahl aufheben",
    loadingUnits: "Wird geladen…",
    currentBadge: "Aktuell",
    unitsWithRate: "{count} Einheit mit Rate | {count} Einheiten mit Rate",
    noBaseRate: "Keine Grundrate",
    noResults: 'Keine Ergebnisse für "{query}"',
    create: "Rate erstellen",
    creating: "Wird erstellt…",
    save: "Speichern",
    saving: "Wird gespeichert…",
  },
  delete: {
    title: "Abgeleitete Rate löschen",
    subtitle: "Bestätigen Sie den Namen, um nicht versehentlich eine Rate zu löschen.",
    confirmCopy: "Geben Sie zur Bestätigung den Namen der Rate ein:",
    deleting: "Wird gelöscht...",
  },
  types: {
    apartment: "Apartment",
    house: "Haus",
    villa: "Villa",
    hotel: "Hotel",
    room: "Zimmer",
    studio: "Studio",
    camping: "Camping",
    default: "Unterkunft",
  },
  misc: {
    noName: "Kein Name",
    unitFallback: "Einheit #{id}",
    basePrefix: "Basis:",
  },
  common: {
    cancel: "Abbrechen",
    delete: "Löschen",
    close: "Schließen",
  },
  toasts: {
    loadError: "Die Raten des Inserats konnten nicht geladen werden",
    loadListingsError: "Die Inserate konnten nicht geladen werden",
    selectUnit: "Wählen Sie mindestens eine Einheit mit einer Grundrate aus.",
    created: "Rate erfolgreich erstellt",
    createdPartial: "Einige Raten konnten nicht erstellt werden",
    createError: "Die Rate konnte nicht erstellt werden",
    updated: "Rate erfolgreich aktualisiert",
    updateError: "Die Rate konnte nicht aktualisiert werden",
    updateErrorGeneric: "Fehler beim Aktualisieren der Rate",
    deleted: "Rate gelöscht",
    deleteError: "Fehler beim Löschen",
    groupUpdated:
      "Rate in {count} Einheit aktualisiert | Rate in {count} Einheiten aktualisiert",
    groupUpdatedPartial: "{success} aktualisiert, {error} mit Fehlern",
    removedFromUnit: "Rate aus dieser Einheit entfernt",
    removeError: "Die Rate konnte nicht entfernt werden",
    removeErrorGeneric: "Fehler beim Entfernen der Rate",
    toggleError: "Der Status der Rate konnte nicht geändert werden",
  },
};
